
<div class="card text-decoration-none bg-emphasis bg-opacity-25">
    <div class="card-body align-items-center text m-5px">
        <div class="d-flex fw-bold small text-truncate text-uppercase" *ngIf="c && c.showTitle">
            {{widget.name}}
        </div>
        <div class="gauge-widget" *ngIf="c && c.timeSeriesList">

             <div *ngIf="c.gaugeType == 'solid' || c.gaugeType == 'speedometer' || c.gaugeType == null">
                <div *ngFor="let ts of c.timeSeriesList">
                    <div *ngIf="!showValue && c.size < 6">
                        <app-gauge #gaugeComp [gaugeLabel]="ts.name" [widgetSize]="c.size" [gaugeConfig]="ts" [gaugeType]="c.gaugeType"></app-gauge>
                    </div>
                    <div *ngIf="showValue || c.size >= 6">
                        <div class="container">
                            <div class="gauge">
                                <app-gauge #gaugeComp [gaugeLabel]="ts.name" [showTitle]="c.showLabel" [widgetSize]="c.size" [gaugeConfig]="ts" [gaugeType]="c.gaugeType"></app-gauge>
                            </div>
                            <div class="gauge-title gauge-text"> 
                                {{ts.name}}
                            </div>
                            <div class="gauge-value gauge-text"> 
                                {{ts.value}} <small *ngIf="ts.value && ts.valueSuffix">{{ts.valueSuffix}}</small>
                            </div>
                        </div>                  
                    </div>
                </div>
            </div>
            
            <div *ngIf="c.gaugeType == 'horizontal'">
                <div class="col-md-12">
                    
                    <div class="mt-3" *ngFor="let ts of c.timeSeriesList">
                        <div>
                            <h6 [class]="'clip'">{{ts.name}}</h6>
                        </div>
                        <div class="range row">
                            <div class="col-4 text-left">{{ts.min}}</div>
                            <div class="col-4 text-center">{{ts.value}} {{ts.valueSuffix}}</div>
                            <div class="col-4 text-right">{{ts.max}}</div>
                        </div>
                        <table class="progress-table" width="100%" [class.highlighted]="ts.highlighted">
                            <tr>
                                <td class="progress-left" [width]="ts.negativeSize + '%'" *ngIf="ts.negativeSize > 0">
                                    <div class="progress progress-small justify-content-end">       
                                        <div [style.width.%]="ts.negative" class="progress-bar" [style.background-color]="ts.colour">{{ts.value}} {{ts.valueSuffix}}</div>
                                    </div>
                                </td>
                                <td class="bar" width="1%" >
                                    
                                </td>
                                <td class="progress-right" [width]="ts.positiveSize + '%'" *ngIf="ts.positiveSize > 0">
                                    <div class="progress progress-small">                            
                                        <div [style.width.%]="ts.positive" class="progress-bar" [style.background-color]="ts.colour">{{ts.value}} {{ts.valueSuffix}}</div>
                                    </div>
                                </td>
                                <td [width]="'100%'" *ngIf="ts.positiveSize == null && ts.negativeSize == null">
                                    <div class="progress progress-small">                            
                                        
                                    </div>
                                </td>
                            </tr>
                        </table>
  
                    </div>
                    
                </div>
            </div>

        </div>
    </div>
</div>